import _ from "lodash";
import { useCallback, useEffect, useState } from "react";
import { formatTimeS } from "../../../helpers";
import { getRadarFrame, ProjectWithData } from "./ProjectWithData";

type ProjectScrubberProps = {
    project: ProjectWithData | undefined;
    setIsScrubbing: (isScrubbing: boolean) => void;
    currentTimeS: number;
    setCurrentTimeS: React.Dispatch<React.SetStateAction<number>>;
    isPlaying: boolean;
    setIsPlaying: React.Dispatch<React.SetStateAction<boolean>>;
};

export const ProjectScrubber: React.FC<ProjectScrubberProps> = ({ setCurrentTimeS, ...props }) => {
    const [mediaDurationS, setMediaDurationS] = useState<number>();

    // eslint-disable-next-line react-hooks/exhaustive-deps
    const throttledScrubToTimeS = useCallback(
        _.throttle((desiredTimeS: number) => {
            setCurrentTimeS(desiredTimeS);
        }, 50)
        , // Maybe we could somehow detect if this is not getting throttled enough?
        [setCurrentTimeS]
    );

    // Handle video time update when scrubbing
    const handleScrubbing = (event: React.ChangeEvent<HTMLInputElement>) => {
        const desiredTimeS = parseFloat(event.target.value);
        throttledScrubToTimeS(desiredTimeS);
    };

    const togglePlay = () => props.setIsPlaying(curValue => !curValue);

    useEffect(() => {
        const startDate = props.project?.getDataStartDate();
        const endDate = props.project?.dataEndDate;

        if (!startDate || !endDate) return;

        setMediaDurationS((endDate.getTime() - startDate.getTime()) / 1000);

    }, [props.project, props.project?.dataEndDate]);

    if (!props.project) return <></>;
    return (
        <div>
            {/*Scrubber - we need to make this stay on top of the video when full screen*/}
            <div className="flex flex-col gap-3 w-full">
                <div className="flex w-full flex-row">
                    <div className="flex flex-grow">
                        <input
                            type="range"
                            min="0"
                            max={(mediaDurationS ?? 0)}
                            value={props.currentTimeS}
                            step=".05"
                            onChange={handleScrubbing}
                            onMouseDown={() => props.setIsScrubbing(true)}
                            onMouseUp={() => props.setIsScrubbing(false)}
                            onTouchStart={() => props.setIsScrubbing(true)}
                            onTouchEnd={() => props.setIsScrubbing(false)}
                            style={{ "width": "100%", "left": "auto", "right": "auto" }}
                        />
                    </div>
                    <div className="min-w-100 text-right text-sm">{formatTimeS(props.currentTimeS)}<br />
                        V: {Math.floor(props.currentTimeS * (props.project?.videoFps ?? 20))}<br />
                        R: {getRadarFrame(props.project, props.currentTimeS)}
                    </div>
                </div>
                <div className="w-full flex gap-3 justify-content-center place-content-center" >
                    <button
                        onClick={() => { setCurrentTimeS(props.currentTimeS - 5); }}
                    >
                        Rewind 5s
                    </button>
                    <button onClick={() => { setCurrentTimeS(props.currentTimeS - 1); }}>-1</button>
                    <button onClick={togglePlay}>{props.isPlaying ? 'Pause' : 'Play'}</button>
                    <button onClick={() => { setCurrentTimeS(props.currentTimeS + 1); }}>+1</button>
                    <button
                        onClick={() => { setCurrentTimeS(props.currentTimeS + 5); }}
                    >
                        Forward 5s
                    </button>
                </div>
                <div>

                </div>
            </div>
        </div>
    );
}